export function formatOverviewUsd(amount: number, compact = false): string {
  if (compact && Math.abs(amount) >= 1000) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      maximumFractionDigits: 1,
    }).format(amount)
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)
}

export function formatOverviewCount(value: number): string {
  return new Intl.NumberFormat('en-US').format(value)
}

/** Campaign master cards — US-SO-1-12 */
export function formatCampaignStatusLabel(status: string): string {
  if (status === 'active') return 'Active'
  if (status === 'completed') return 'Completed'
  if (status === 'draft') return 'Draft'
  return status.charAt(0).toUpperCase() + status.slice(1)
}

/** Instrument rows — US-SO-1-18 (Active / Complete / Expire) */
export function formatInstrumentStatusLabel(status: string): string {
  if (status === 'active') return 'Active'
  if (status === 'complete') return 'Complete'
  if (status === 'expire') return 'Expire'
  if (status === 'draft') return 'Draft'
  return status.charAt(0).toUpperCase() + status.slice(1)
}

/** @deprecated Use formatCampaignStatusLabel or formatInstrumentStatusLabel */
export function formatOverviewStatusLabel(status: string): string {
  return formatCampaignStatusLabel(status)
}

export function formatOverviewDate(iso: string | null): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(d)
}

export function formatOverviewDateTime(iso: string | null): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  const date = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(d)
  const time = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: false,
  }).format(d)
  return `${date} · ${time}`
}

export function tenantInitials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('')
}

export function tokenBarColor(percent: number): string {
  if (percent > 30) return '#22c55e'
  if (percent > 15) return '#f59e0b'
  return '#ef4444'
}

/** US-SO-1-2 — type tag display labels */
export const SENSEMAKER_TYPE_TAG_LABEL: Record<string, string> = {
  individual: 'Individual',
  agency: 'Agency',
  team: 'Team',
  company: 'Company',
}

/** US-SO-1-2 — color-coded type tags */
export const SENSEMAKER_TYPE_TAG_STYLES: Record<
  string,
  { bg: string; border: string; color: string }
> = {
  individual: { bg: '#e3f2fd', border: '#3285d7', color: '#1976d2' },
  agency: { bg: '#f3e8ff', border: '#a855f7', color: '#7e22ce' },
  team: { bg: '#dcfce7', border: '#22c55e', color: '#15803d' },
  company: { bg: '#ffedd5', border: '#f97316', color: '#c2410c' },
}

/** Normalize package label punctuation to match Figma (`Package 03 - Enterprise Plan`). */
export function formatPackageLabel(label: string): string {
  return label.replace(/\s*—\s*/g, ' - ').replace(/\s*-\s*/g, ' - ')
}
